"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1794))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:44:59.939Z
 */
export const Pound = createSVGIcon(
  <>
    <path
      d="M0.5 12.5C0.5 15.6826 1.76428 18.7348 4.01472 20.9853C6.26516 23.2357 9.3174 24.5 12.5 24.5C15.6826 24.5 18.7348 23.2357 20.9853 20.9853C23.2357 18.7348 24.5 15.6826 24.5 12.5C24.5 9.3174 23.2357 6.26516 20.9853 4.01472C18.7348 1.76428 15.6826 0.5 12.5 0.5C9.3174 0.5 6.26516 1.76428 4.01472 4.01472C1.76428 6.26516 0.5 9.3174 0.5 12.5V12.5Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.54421 12.1297C8.54421 12.4187 8.77846 12.653 9.06742 12.653H9.92818C10.1307 13.4124 10.3164 14.1213 10.3164 14.8639C10.3164 15.2859 10.232 15.6234 10.1138 15.9103C9.2622 16.0708 8.76258 16.6916 8.52916 17.3106C8.40051 17.6518 8.6894 17.9694 9.05405 17.9694C9.36947 17.9694 9.61525 17.7119 9.8024 17.458C9.97222 17.2276 10.2596 17.058 10.7045 17.058C11.6666 17.058 12.9661 18.1213 14.4514 18.1213C15.8075 18.1213 16.6703 17.2951 16.9556 16.0853C17.037 15.7402 16.7502 15.4378 16.3955 15.4378C16.0713 15.4378 15.8187 15.6963 15.7202 16.0053C15.511 16.6613 14.9999 16.8892 14.2826 16.8892C13.5569 16.8892 12.4936 16.2479 11.3797 15.9778C11.5147 15.6572 11.5991 15.2859 11.5991 14.8808C11.5991 14.0369 11.4809 13.3281 11.3459 12.653H14.1813C14.4703 12.653 14.7045 12.4187 14.7045 12.1297C14.7045 11.8408 14.4703 11.6065 14.1813 11.6065H11.1096C10.9577 10.8977 10.8227 10.1551 10.8227 9.24367C10.8227 7.8597 11.751 6.94831 13.0505 6.94831C14.2157 6.94831 14.797 7.43871 15.0956 8.3418C15.2078 8.68095 15.5039 8.93987 15.8611 8.93987C16.2931 8.93987 16.6413 8.56747 16.5261 8.15121C16.1182 6.67741 14.8997 5.75 13.0505 5.75C10.9577 5.75 9.33746 7.16772 9.33746 9.22679C9.33746 10.1213 9.47248 10.8977 9.64126 11.6065H9.06742C8.77846 11.6065 8.54421 11.8408 8.54421 12.1297Z"
      fill="currentColor"
    />
  </>,
  "Pound",
  { viewBox: "0 0 25 25", fill: "none", color: Core.icon.default } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
